import "./changePasswordscreen.css";
import React, { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom";
import OutlinedInput from '@mui/material/OutlinedInput';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PasswordChecklist from "react-password-checklist";
import { authKey, FORGOT_PASSWORD, VALIDATE_STAKEHOLDER, VALIDATE_STAKEHOLDER_OTP, VALIDATE_ABRPL_USER, VALIDATE_ABRPL_USER_OTP } from '../URLs';
import resolveIcon from "../../images/resolved.png";
import { loaderService } from '../custom-loader/loader-service';
import { toast } from 'react-toastify';
import { otpMaxLength, emailUrnPassMaxLength } from '../commonValidations';
import { useLocation } from "react-router-dom";
import { Button, Container, Card, CardContent, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import BackButton from '../../common/backButton';
import { PROD } from '../../common/constants';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { ConfirmationPopover } from "../commonPopovers/confirmationPopover";
import apiClient from "../../axios";

function ForgotPasswordScreen() {

    const navigate = useNavigate();
    const [isApiCalled, setIsApiCalled] = useState(false);
    const userDetails = useLocation().state?.selectedRow;
    const {userType} = useParams();
    const [pass, setPass] = useState("")
    const [oid, setOid] = useState("")
    const [password, setPassword] = useState("")
    const [passwordAgain, setPasswordAgain] = useState("")
    const [showPassword, setShowPassword] = React.useState(false);
    const [IsValid, setIsValid] = useState("")
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [urnOrEmail, setUrnOrEmail] = useState(userType === "abrpluser" ? userDetails?.emailAddress : '');
    const [otp, setOtp] = useState('');
    const [errorMessage, setErrorMessage] = useState({
        otpError: '',
        urnOrEmailError: ''
    });
    const [isUrnOrEmailValid, setIsUrnOrEmailValid] = useState("Not Clicked yet");
    const [isOtpValid, setIsOtpValid] = useState("Not verified yet");

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

// const onConfirmSubmit = () => {
//     handleLogModalClose();
//     changePassword();
// }

 
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await changePassword();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen(false);
            setIsApiCalled(false);
        }
    };

    const onChangePassword = () => {
        handleLogModalOpen();
    }

    function changePassword() {
        apiClient
            .post(FORGOT_PASSWORD,
                {
                    "oid": oid,
                    "password": password,
                },
                {
                    headers: {
                        AuthKey: authKey,
                    }
                }
            )
            .then((response) => {
                setPass(response.data)
                toast.success(response.data.message);
                navigate('/')
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const handleChange = (e) => {
        setUrnOrEmail(e.target.value)
        setIsUrnOrEmailValid("Not Clicked yet");
        setErrorMessage({ ...errorMessage, urnOrEmailError: "" });
    }

    const onOtpChange = (e) => {
        // setIsOtpValid("Not verified yet")
        // setErrorMessage({ ...errorMessage, otpError: "" });
        // const limit = 6;
        setOtp(e.target.value)
        if (e.target.value.length == 6) {
            userType === "stakeholder" ? verifyStakeHolderOTP(e.target.value) : verifyABRPLUserOTP(e.target.value);
        }
        // else {
        //     setErrorMessage({...errorMessage, otpError: "Please enter 6 digit otp"})
        // }
    }

    const validateStakeholder = () => {
        loaderService.showLoader();
        apiClient.post(VALIDATE_STAKEHOLDER,
            {
                // "type": "string",
                // "pincode": "string",
                // "status": "string",
                "urn": urnOrEmail,
                // "mobile": "string"
            },
            {
                headers: {
                    AuthKey: authKey,
                }
            })
            .then((response) => {
                if (response?.data?.isExist === false) {
                    setIsUrnOrEmailValid(false)
                    setErrorMessage({ ...errorMessage, urnOrEmailError: "Invalid URN" })
                }
                else if (response?.data?.isSMSSent === "false") {
                    toast.error("Something went wrong! Please try again")
                }
                else {
                    setErrorMessage({ ...errorMessage, urnOrEmailError: "" })
                    setIsUrnOrEmailValid(true)
                }
                // toast.success(response.data.message)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message)
            });

    }

    const verifyStakeHolderOTP = (currentOtp) => {
        loaderService.showLoader();
        apiClient.post(VALIDATE_STAKEHOLDER_OTP,
            {
                "loginID": urnOrEmail,
                "otp": currentOtp
            },
            {
                headers: {
                    AuthKey: authKey,
                }
            })
            .then((response) => {
                // toast.success(response.data.message)
                if (response.data.isSuccess === false) {
                    setIsOtpValid(false)
                    setErrorMessage({ ...errorMessage, otpError: "Invalid OTP" })
                }
                else if (response?.data?.oid == null) {
                    toast.error("You have not yet signed up. Please complete the sign up process")
                }
                else {
                    setIsOtpValid(true)
                    setOid(response?.data?.oid)
                }
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message)
            });

    }

    const validateABRPLUser = () => {
        loaderService.showLoader();
        apiClient.post(VALIDATE_ABRPL_USER,
            {
                // "userID": "string",
                // "mobileNumber": "string",
                "emailAddress": urnOrEmail,
                // "userRole": "string"
            },
            {
                headers: {
                    AuthKey: authKey,
                }
            })
            .then((response) => {
                if (response?.data?.isExist === false) {
                    setIsUrnOrEmailValid(false)
                    setErrorMessage({ ...errorMessage, urnOrEmailError: "Invalid Email" })
                }
                else if (response?.data?.isSMSSent === "false") {
                    toast.error("Something went wrong! Please try again")
                }
                else {
                    setErrorMessage({ ...errorMessage, urnOrEmailError: "" })
                    setIsUrnOrEmailValid(true)
                }
                // toast.success(response.data.message)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message)
            });

    }

    const verifyABRPLUserOTP = (currentOtp) => {
        loaderService.showLoader();
        apiClient.post(VALIDATE_ABRPL_USER_OTP,
            {
                "loginID": urnOrEmail,
                "otp": currentOtp
            },
            {
                headers: {
                    AuthKey: authKey,
                }
            })
            .then((response) => {
                // toast.success(response.data.message)
                if (response.data.isSuccess === false) {
                    setIsOtpValid(false)
                    setErrorMessage({ ...errorMessage, otpError: "Invalid OTP" })
                }
                else if (response?.data?.oid == null) {
                    toast.error("You have not yet signed up. Please complete the sign up process")
                }
                else {
                    setIsOtpValid(true)
                    setOid(response?.data?.oid)
                }
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message)
            });

    }

    const onClickValidateURNOrEmail = () => {
        userType === 'stakeholder' ? validateStakeholder() : validateABRPLUser();
    }

    return (
        <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG10</p>}
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <BackButton navigate={navigate} navigateTo="/" />
          <Typography variant="h5" gutterBottom>
          Forgot Password
          </Typography>
        </Stack>
        <Card>
          <CardContent >
          <Grid container spacing={2} direction="column" style={{ display: "flex", alignItems: "center", justifyContent: "center"}}>
            <Grid item xs={12} lg={4} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
            <TextField fullWidth  sx={{ mt: 2}}
                                error={isUrnOrEmailValid === false}
                                helperText={errorMessage.urnOrEmailError}
                                id="outlined-adornment-password"
                                name="urnorEmail"
                                value={urnOrEmail}
                                inputProps={{
                                    maxLength: emailUrnPassMaxLength
                                }}
                                onChange={(e) => handleChange(e)}
                                label={userType === 'stakeholder' ? "URN" : "Email"} />
                            {isUrnOrEmailValid === true ? <div style={{ display: "flex", alignSelf: "end" }}>
                                <img className="otp-verified-icon" src={resolveIcon} alt="" />
                                <a className="otp-verified-text" href="#">{userType === 'stakeholder' ? "URN" : "Email"} Valid</a>
                            </div> :
                                <button className="verifyText-forget-password" onClick={(e) => onClickValidateURNOrEmail(e)}>Validate {userType === 'stakeholder' ? "URN" : "Email"}</button>}
                        {isUrnOrEmailValid === true &&
                            isOtpValid === true ? <div style={{ display: "flex", alignSelf: "end" }}>
                                    <img className="otp-verified-icon" src={resolveIcon} alt="" />
                                    <a className="otp-verified-text" href="#">OTP Verified</a>
                                </div> : <><TextField sx={{ mt: 2 }} fullWidth
                                    id="outlined-adornment-password"
                                    error={isOtpValid === false}
                                    helperText={errorMessage.otpError}
                                    inputProps={{
                                        maxLength: otpMaxLength
                                    }}
                                    name="otp"
                                    value={otp}
                                    onChange={(e) => onOtpChange(e)}
                                    label="OTP"
                                />
                                    {isOtpValid === false && <button className="verifyText-forget-password" onClick={(e) => onClickValidateURNOrEmail(e)}>Resend OTP</button>}</>}
                                    <FormControl fullWidth sx={{ mt: 2 }} variant="outlined">
                                <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    type={showPassword ? 'text' : 'password'}
                                    onChange={e => setPassword(e.target.value)}
                                    inputProps={{
                                        maxLength: emailUrnPassMaxLength
                                    }}
                                    // disabled={!mobileOTPValidated}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"

                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="New Password"
                                />
                            </FormControl>
                            <FormControl fullWidth sx={{ mt: 2 }} variant="outlined">
                                <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    type={showPassword ? 'text' : 'password'}
                                    onChange={e => setPasswordAgain(e.target.value)}
                                    inputProps={{
                                        maxLength: emailUrnPassMaxLength,
                                        autoCapitalize: 'none',
                                        autoCorrect: 'off',
                                        spellCheck: 'false' 

                                    }}
                                    // disabled={!mobileOTPValidated}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Confirm Password"
                                />
                            </FormControl>
                            <PasswordChecklist
                                rules={["minLength", "specialChar", "number", "capital", "match"]}
                                minLength={8}
                                value={password}
                                valueAgain={passwordAgain}
                                onChange={(isValid) => setIsValid(isValid)}
                            />
                            <Button className='password-btn' onClick={(e) => onChangePassword(e)} disabled={!IsValid || !isUrnOrEmailValid || !isOtpValid}>Change Password</Button>
            </Grid>
            </Grid>
          </CardContent>
          </Card>
          </Container>
          <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmSubmit} onClose={handleLogModalClose} action="Change Password" />
         
          </>
    );
}


export default ForgotPasswordScreen;
